import React, { useState } from "react";
import {
  MainRow,
  MainCol,
  MainContainer,
  Select,
  InputField,
  Buttons,
  Loader,
} from "components/common";
import { blockchainSelect } from "components/data/selectData";
import { MoralisCollectionHook, useForm } from "hooks";
import { moralisCollectionValidate } from "components/validation/customValidator";
import { ContractUtility } from "utility";
const ImportCollectionComp = () => {
  const [reqData, setReqData] = useState({
    protocol: '',
    address: "",
  });

  const { moralisFetchData, data, loading } = MoralisCollectionHook();

  const submit = () => {
    moralisFetchData( ContractUtility.getMoralisSymbol(reqData.protocol), reqData.address);
  };

  const { handleSubmit, errors } = useForm(
    submit,
    moralisCollectionValidate,
    reqData
  );

  return (
    <div>
      {loading && <Loader content="Importing collection..." />}
      <MainContainer importCollection>
        <h3 className="text-white mt-5">Enter Your Contact Address</h3>

        <p className="text-white  mt-5">
          What is the Address of your ERC21 or ERC1155 contract on the mainnet
          Network
        </p>
        <MainRow style={{ marginTop: "-3rem" }} className="g-2">
          <MainCol lg={3}>
            <Select
              error={errors.protocol}
              value={reqData.protocol}
              setValue={(e) => setReqData({ ...reqData, protocol: e })}
              dropDownList={blockchainSelect}
            />
          </MainCol>
          <MainCol lg={8}>
            <InputField
              error={errors.address}
              value={reqData.address}
              setValue={(e) =>
                setReqData({ ...reqData, address: e.target.value })
              }
              placeholder="e.g 0xdfdf... or destination.eth"
              inputType="text"
              isImportInput
            />
          </MainCol>
        </MainRow>
        <Buttons onClick={handleSubmit} isSumbitBtn>Submit</Buttons>
      </MainContainer>
    </div>
  );
};

export default ImportCollectionComp;
